<script setup lang="ts">
import type { Schemas } from "#shopware";
import {
  buildUrlPrefix, getProductRoute,
  getSmallestThumbnailUrl,
  getTranslatedProperty
} from "@shopware/helpers";
import {computed} from "vue";
import {useUrlResolver} from "#imports";
const { getUrlPrefix } = useUrlResolver();
const props = defineProps<{
  product: Schemas["Product"],
}>();
const { product } = toRefs(props);
const productName = computed(() =>
    getTranslatedProperty(props.product, "name"),
);

const srcPath = computed(() => {
  let imageUrl = getSmallestThumbnailUrl(
      product.value?.cover?.media,
  );
  if(imageUrl) {
    return `${getSmallestThumbnailUrl(
        product.value?.cover?.media,
    )}`;
  }

  imageUrl = product.value?.cover?.media?.url
  if(imageUrl) {
    return imageUrl;
  }
  return null;
});

const loading = ref(true);
onMounted(() => {
  loading.value = false;
});
</script>

<template>
      <div class="card__image">
        <NuxtImg
            class="product-img-cover"
            provider="ipx"
            format="webp"
            fit="cover"
            :src="srcPath ? srcPath : ''"
            preset="listing"
            loading="lazy"
            data-testid="product-box-img"
            :class="{
                  'no-hover': (srcPath && srcPath.substring(srcPath.length - 3) === 'jpg')
                }"
            :alt="productName || ''"

            ref="imageElement"
        >
        </NuxtImg>
      </div><!-- /.card__image -->
</template>
